import { cn } from "@/lib/tailwind";
import React from "react";

interface IProps {
  className?: string;
}

const Spinner = ({ className = "" }: IProps) => {
  return (
    <div className="flex min-h-screen items-center justify-center">
      <div
        className={cn(
          "h-4 w-4 animate-spin rounded-full border-2 border-solid border-black border-t-transparent",
          className,
        )}
      ></div>
    </div>
  );
};

export default Spinner;
